import React from 'react';
import './ChallengeCard.css';

function ChallengeCard({ challenge, currentUserId, onJoin, onViewDetails, onEdit, onCancel, getTimeRemaining, formatEndTime }) {
  const handleJoinClick = (e) => {
    e.stopPropagation();
    onJoin(challenge.id);
  };

  const handleViewClick = (e) => {
    e.stopPropagation();
    onViewDetails(challenge.id);
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    onEdit(challenge.id);
  };

  const handleCancelClick = (e) => {
    e.stopPropagation();
    onCancel(challenge.id);
  };

  const isOwner = challenge.created_by_user_id === currentUserId;
  const canEditOrCancel = isOwner && challenge.status === 'accepting';

  return (
    <div 
      className={`challenge-card-full ${challenge.status}`}
      onClick={() => onViewDetails(challenge.id)}
    >
      <div className="challenge-card-header-full">
        <div className="header-left">
          <h3 className="challenge-title-full">{challenge.title}</h3>
          <span className={`challenge-status-badge ${challenge.status}`}>
            {challenge.status === 'accepting' && '⏰ Open'}
            {challenge.status === 'active' && '🔥 Active'}
            {challenge.status === 'completed' && '✓ Completed'}
            {challenge.status === 'cancelled' && '❌ Cancelled'}
          </span>
        </div>
        {canEditOrCancel && (
          <div className="challenge-actions">
            <button className="edit-challenge-btn" onClick={handleEditClick} title="Edit Challenge">
              ✏️
            </button>
            <button className="cancel-challenge-btn" onClick={handleCancelClick} title="Cancel Challenge">
              🗑️
            </button>
          </div>
        )}
      </div>
      
      {challenge.description && (
        <p className="challenge-description">{challenge.description}</p>
      )}
      
      <div className="challenge-meta">
        <div className="meta-item">
          <span className="meta-label">Created by:</span>
          <span className="meta-value">{challenge.creator_first_name} {challenge.creator_last_name}</span>
        </div>
        <div className="meta-item">
          <span className="meta-label">Type:</span>
          <span className="meta-value">
            {challenge.challenge_type === 'count_tasks' ? `First to ${challenge.target_number}` : 'Time-based'}
          </span>
        </div>
        {challenge.prize && (
          <div className="meta-item">
            <span className="meta-label">Prize:</span>
            <span className="meta-value prize">🏆 {challenge.prize}</span>
          </div>
        )}
      </div>
      
      {challenge.status === 'accepting' && (
        <div className="challenge-accepting-section">
          <div className="countdown-section">
            <span className="countdown-label">Time to join:</span>
            <span className="countdown-value">{getTimeRemaining(challenge.acceptance_deadline)}</span>
          </div>
          {challenge.user_is_participant === 0 && (
            <button className="join-btn-full" onClick={handleJoinClick}>
              Join Challenge
            </button>
          )}
          {challenge.user_is_participant > 0 && (
            <div className="joined-indicator">✓ You're In</div>
          )}
        </div>
      )}
      
      {challenge.status === 'active' && challenge.top_3 && (
        <div className="challenge-leaderboard-section">
          <h4 className="leaderboard-title">Top 3</h4>
          <div className="leaderboard-mini">
            {challenge.top_3.map((participant, index) => (
              <div key={participant.user_id} className={`leader-item rank-${index + 1}`}>
                <span className="rank-medal">
                  {index === 0 && '🥇'}
                  {index === 1 && '🥈'}
                  {index === 2 && '🥉'}
                </span>
                <span className="leader-name">{participant.first_name} {participant.last_name}</span>
                <span className="leader-score">{participant.score} pts</span>
              </div>
            ))}
          </div>
          {challenge.challenge_type === 'time_based' && challenge.end_time && (
            <div className="challenge-deadline">
              Ends: {formatEndTime(challenge.end_time)}
            </div>
          )}
        </div>
      )}
      
      {challenge.status === 'completed' && (
        <div className="challenge-completed-section">
          {challenge.winner_first_name && (
            <div className="winner-announcement">
              <span className="trophy-icon">🏆</span>
              <span className="winner-text">
                Winner: <strong>{challenge.winner_first_name} {challenge.winner_last_name}</strong>
              </span>
            </div>
          )}
          {challenge.top_3 && challenge.top_3.length > 0 && (
            <div className="final-leaderboard">
              {challenge.top_3.map((participant, index) => (
                <div key={participant.user_id} className="final-rank-item">
                  <span className="rank-position">#{index + 1}</span>
                  <span className="rank-name">{participant.first_name} {participant.last_name}</span>
                  <span className="rank-score">{participant.score} pts</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      
      <div className="challenge-footer-full">
        <span className="participant-count">
          👥 {challenge.participant_count} participant{challenge.participant_count !== 1 ? 's' : ''}
        </span>
        <button className="view-details-btn" onClick={handleViewClick}>
          View Details →
        </button>
      </div>
    </div>
  );
}

export default ChallengeCard;

